import { memo, useContext } from "react";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { data1 } from "../App";

function Mobsecondlist(props) {
  const setServiceseta = useContext(data1);
  const changer = {
    display: `${props.second}`,
  };
  function seconder() {
    props.setTop("block");
    props.setSecond("none");
    props.setThree("none");
    props.setFour("none");
  }
  return (
    <>
      <div style={changer}>
        <div className="mobbag">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div>
                <button className="footinfo backback">
                  <div className="arrowicon mobicocrn">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/joint.png"
                    />
                  </div>
                  <h6>Orthopedic Services</h6>
                </button>

                {/* ✅ NEW (not in old list) */}
                <Link
                  to="/service/orthopaedicClinic"
                  onClick={() => {
                    setServiceseta("Orthopaedic Clinic");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Orthopaedic Clinic</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/orthopaedicConsultation"
                  onClick={() => {
                    setServiceseta("Orthopaedic Consultation");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Orthopaedic Consultation</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/orthopaedicEvaluation"
                  onClick={() => {
                    setServiceseta(
                      "Evaluation and Diagnosis of Bone, Joint, Muscle and Ligament Problems",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Evaluation & Diagnosis of Ortho Problems</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/treatmentPlanning"
                  onClick={() => {
                    setServiceseta("Personalized Treatment Planning");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Personalized Treatment Planning</h6>
                </Link>

                {/* ✅ OLD (keep as is) */}
                <Link
                  to="/service/boneFracture"
                  onClick={() => {
                    setServiceseta(
                      "Bone Fracture Treatment Surgical And Conservative Treatment",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>
                    Bone Fracture Treatment Surgical And Conservative Treatment
                  </h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/fractureTraumaCare"
                  onClick={() => {
                    setServiceseta("Fracture & Trauma Care");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Fracture & Trauma Care</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/plasterCasting"
                  onClick={() => {
                    setServiceseta(
                      "Plaster Casting, Splinting and Follow-up Care",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Plaster Casting, Splinting & Follow-up Care</h6>
                </Link>

                {/* ✅ OLD (keep as is) */}
                <Link
                  to="/service/sportMedicine"
                  onClick={() => {
                    setServiceseta("Sport Medicine");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Sport Medicine</h6>
                </Link>

                {/* ✅ NEW (different from Sport Medicine; not repeated) */}
                <Link
                  to="/service/sportsInjury"
                  onClick={() => {
                    setServiceseta("Sports Injury Management");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Sports Injury Management</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/ligamentInjuries"
                  onClick={() => {
                    setServiceseta("Ligament Injuries (ACL, PCL, Meniscus)");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Ligament Injuries (ACL, PCL, Meniscus)</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/tendonMuscleInjuries"
                  onClick={() => {
                    setServiceseta("Tendon Injuries and Muscle Strains");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Tendon Injuries & Muscle Strains</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/returnToSport"
                  onClick={() => {
                    setServiceseta("Return-to-Sport Rehabilitation");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Return-to-Sport Rehabilitation</h6>
                </Link>

                {/* ✅ OLD (keep as is) */}
                <Link
                  onClick={() => {
                    setServiceseta(
                      "Arthroscopic Acl Andmenicus Repair Reconstruction",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  to="/service/arthroscopicAcl"
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Arthroscopic Acl Andmenicus Repair Reconstruction</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/arthroscopy"
                  onClick={() => {
                    setServiceseta("Arthroscopy (Keyhole Surgery)");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Arthroscopy (Keyhole Surgery)</h6>
                </Link>

                {/* ✅ OLD (keep as is) */}
                <Link
                  onClick={() => {
                    setServiceseta("Arthroscopic Shoulder Surgeries");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  to="/service/arthroscopicShoulder"
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Arthroscopic Shoulder Surgeries</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/arthritisJointPain"
                  onClick={() => {
                    setServiceseta(
                      "Arthritis & Joint Pain Management (knee, hip, shoulder, spine)",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Arthritis & Joint Pain Management</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/jointReplacement"
                  onClick={() => {
                    setServiceseta(
                      "Joint Replacement Services (knee replacement, hip replacement)",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Joint Replacement Services</h6>
                </Link>

                {/* ✅ OLD (keep as is) */}
                <Link
                  onClick={() => {
                    setServiceseta(
                      "Back Pain And Disc Related Diseases Treatment",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  to="/service/backPain"
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Back Pain And Disc Related Diseases Treatment</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/backSpineCare"
                  onClick={() => {
                    setServiceseta(
                      "Back & Spine Care (neck pain, low back pain, sciatica)",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Back & Spine Care</h6>
                </Link>

                {/* ✅ OLD (keep as is) */}
                <Link
                  onClick={() => {
                    setServiceseta(
                      "Knee And Hip Replacement Surgery Primary And Revision",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  to="/service/kneeAndHip"
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Knee And Hip Replacement Surgery Primary And Revision</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/paediatricOrthopaedics"
                  onClick={() => {
                    setServiceseta("Paediatric Orthopaedics");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Paediatric Orthopaedics</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/congenitalOrtho"
                  onClick={() => {
                    setServiceseta(
                      "Congenital Deformities & Growth Related Issues",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Congenital Deformities & Growth Issues</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/painManagement"
                  onClick={() => {
                    setServiceseta("Pain Management Procedures");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Pain Management Procedures</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/jointInjections"
                  onClick={() => {
                    setServiceseta("Joint Injections");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Joint Injections</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/prpTherapy"
                  onClick={() => {
                    setServiceseta(
                      "PRP and Non-Surgical Pain Relief Options",
                    );
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>PRP & Non-surgical Pain Relief Options</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/rehabilitation"
                  onClick={() => {
                    setServiceseta("Rehabilitation & Physiotherapy Guidance");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Rehabilitation & Physiotherapy Guidance</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/postOpRehab"
                  onClick={() => {
                    setServiceseta("Post-Operative Rehabilitation Protocols");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Post-operative Rehabilitation Protocols</h6>
                </Link>

                {/* ✅ NEW */}
                <Link
                  to="/service/mobilityExercises"
                  onClick={() => {
                    setServiceseta("Strengthening and Mobility Exercises");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Strengthening & Mobility Exercises</h6>
                </Link>

                {/* ✅ OLD (keep as is) */}
                <Link
                  onClick={() => {
                    setServiceseta("Diabetic Wound Dressing And Management");
                    props.setFirst("none");
                    props.setTop("block");
                    props.setSecond("none");
                  }}
                  to="/service/diabeticWound"
                  className="footinfo cenmenmob"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Diabetic Wound Dressing And Management</h6>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <button onClick={seconder} className="footinfo backback">
          <div className="arrowicon mobicocrn">
            <LazyLoadImage className="arrowbar" src="../photo/error.png" />
          </div>
          <h6>Back</h6>
        </button>
      </div>
    </>
  );
}
export default memo(Mobsecondlist);
